import { ColoredLink, LinkWrap } from 'components/header/shareComponents';
import Link from 'next/link';
import boatsetterPaths from 'utils/boatsetterPaths';
import { shouldBypassClerk } from 'helpers/clerk';

type Props = {
  onSignup: () => void;
  onLogin: () => void;
};

export default function AuthLinks({ onLogin, onSignup }: Props) {
  const signupPath = shouldBypassClerk() ? boatsetterPaths.signUp : boatsetterPaths.auth.root;
  const loginPath = shouldBypassClerk() ? boatsetterPaths.logIn : boatsetterPaths.auth.root;

  return (
    <>
      <LinkWrap>
        <ColoredLink onClick={() => onSignup()}>
          <Link href={signupPath}>Sign&nbsp;up</Link>
        </ColoredLink>
      </LinkWrap>
      <LinkWrap>
        <ColoredLink onClick={() => onLogin()}>
          <Link href={loginPath}>Log&nbsp;in</Link>
        </ColoredLink>
      </LinkWrap>
    </>
  );
}
